<template>
  <button :disabled="disabled" class="pagination-button">
    <i :class="icon" class="icon" :style="{ color: disabled ? colors.pagination.buttonDisabled : colors.pagination.button }"></i>
  </button>
</template>

<script>
import { colors } from '@/infrastructure/Configuration'

export default {
  data: () => {
    return {
      colors
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
  .pagination-button {
    margin: 0 17px;
    padding: 0;
    border: none;
    outline: none;
    background-color: transparent;
    width: auto;

    .icon {
      width: auto;
      color: #B1281E;
      height: 16px;
      line-height: 16px;
      font-size: 12px;
    }
  }
</style>
